<template>
  <div>
    <!-- <Individual
      v-if="$route.query.user_type === 'Individual'"
      :kycData="kycData"
      @getkycData="getIndividualKYC"
    /> -->
    <Bussiness v-if="$route.query.user_type === 'Business'" />
  </div>
</template>
<script>
// import Individual from "./Individual.vue";
import Bussiness from "./Bussiness.vue";
import userService from "@/services/UserService/userService.js";
export default {
  name: "",
  props: ["user_type"],
  components: {
    // Individual,
    Bussiness,
  },
  data() {
    return {
      selectedComponent: null,
      kycData: null,
    };
  },
  computed: {},
  watch: {},
  async mounted() {
    if (this.$route.query.user_type === "Business") {
      this.getBusinessKYC();
    } else {
      await this.getIndividualKYC();
      console.log(this.kycData, "profileData");
      if (this.kycData !== undefined) {
        this.selectedComponent = this.$route.query.user_type;
      }
    }
  },
  methods: {
    async getIndividualKYC() {
      const params = {
        customer_id: !isNaN(this.$route.query.customer_id || this.$route.query.id || this.$route.query.customerid) && !isNaN(parseFloat(this.$route.query.customer_id || this.$route.query.id || this.$route.query.customerid)) ? parseInt(this.$route.query.customer_id || this.$route.query.id || this.$route.query.customerid, 10) : (this.$route.query.customer_id || this.$route.query.id || this.$route.query.customerid),
      };
      try {
        const responseData = await userService.getIndKYC(params);
        if (responseData.data.status_code === 200) {
          if (responseData.data.data && responseData.data.data.length > 0) {
            this.kycData = responseData.data.data;
          } else {
            this.kycData = null;
          }
        }
      } catch (e) {
        console.error(e);
      }
    },

    async created() {},
  },
};
</script>
<style lang="" scoped></style>
